import { captureMessage } from '@sentry/react';
import { useMutation } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { apiClient } from '@cast/infrastructure-api';
import { raiseReportingMonetizationEvent } from '@cast/shared-trial-ui';

import {
  buildReportingContactSalesFormBody,
  REPORTING_CONTACT_SALES_PAGE_NAME,
  type ReportingContactSalesPayload,
} from './_utils';

export const useSubmitReportingContactSalesMutation = () => {
  return useMutation({
    mutationFn: (payload: ReportingContactSalesPayload) =>
      apiClient.hubspot.submitReportingContactSales(
        buildReportingContactSalesFormBody(payload, {
          pageUri: window.document.URL,
          pageName: REPORTING_CONTACT_SALES_PAGE_NAME,
        })
      ),
    onSuccess: (_data, payload) => {
      raiseReportingMonetizationEvent('reporting_sales_contacted', {
        source: 'hubspot_form',
        organization_id: payload.orgId,
      });
    },
    onError: (error, payload) => {
      const parsedError = parseApiError(error);
      captureMessage(
        `Hubspot: Unable to submit reporting contact sales form. Payload: ${JSON.stringify(
          payload
        )}; Error: ${parsedError}`
      );
    },
  });
};
